import React from 'react'

function HorizontalScroll({ children }) {
  return (
    <div className="-mx-4 px-4 md:mx-0 md:px-0 flex gap-4 md:gap-6 lg:gap-6 overflow-scroll hide-scroll">
      {children}
    </div>
  )
}

export default HorizontalScroll
